import { Icon, Text } from '@joor/design-system'
import styled from 'styled-components'

import {
  DefaultContainer,
  commonTextProps,
} from '../../ReassignConnectionsModal.ui'
import IDs from '../../reassignConnectionsModal.ids'
import messages from '../../reassignConnectionsModal.messages'
import { Actions } from '../../reassignConnectionsModal.types'
import useStore from '../../store/useReassignConnectionsStore'

const WarningContainer = styled(DefaultContainer)`
  border: 1px solid var(--color-warning-400);
  background-color: var(--color-warning-100);

  svg {
    --main-color: var(--color-warning-800);
  }

  &&& p {
    color: var(--color-warning-800);
  }
`

const RemoveWarning = (): JSX.Element | null => {
  const action = useStore((state) => state.action)
  const sourceUser = useStore((state) => state.sourceUser)

  if (!sourceUser || action !== Actions.REMOVE) {
    return null
  }

  return (
    <WarningContainer id={IDs.Warning} data-testid={IDs.Warning}>
      <Icon iconName="exclamation" />
      <Text {...commonTextProps}>
        <strong>{messages.warning}:</strong>{' '}
        {messages.warningDesc.replace(
          '{amount}',
          sourceUser.numberConnections?.toString() || '',
        )}
      </Text>
    </WarningContainer>
  )
}

export default RemoveWarning
